<template>
  <b-container fluid>
    <h1>Audit Log</h1>
    <b-row class="justify-content-md-center">
      <b-col class="my-1" cols=4>
        <b-input-group>
          <b-form-input
            v-model="filter"
            placeholder="Type to Search"
            @keydown.enter.native="updateLog"
          />
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">
              Clear
            </b-button>
            <b-button :disabled="!filter" @click="updateLog">
              Search
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col class="my-1" cols="3">
        <b-pagination
          align="right"
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="mb-0"
        />
      </b-col>
    </b-row>

    <fingerprint-spinner
      v-if="loading"
      :animation-duration="1500"
      :size="300"
      color="#293a93"
      class="my-3"
    />

    <b-table
      v-else
      striped
      hover
      class="wide-table"
      :fields="columns"
      :items="logEntries"
      sort-by.sync=""
      sort-by="datecreated"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-desc="true"
    >
      <template slot="when" slot-scope="data">
        <NiceDate :value="String(data.item.datecreated)" />
      </template>
      <template slot="identity" slot-scope="data">
        <span v-if="data.item.pc">{{ data.item.pc }}</span>
        <span v-else>{{ data.item.ip }}</span>
      </template>
      <template slot="order" slot-scope="data">
        <router-link
          v-if="data.item.soNum"
          target="_blank"
          :to="{ name: 'View Order', params: { id: data.item.soNum} }"
        >
          {{ data.item.soNum }}
        </router-link>
        <span v-else>
          -
        </span>
      </template>
    </b-table>

    <AuditDiff :open="openDiff" :so-num="diffSoNum" @closediff="openDiff=false" />
  </b-container>
</template>

<script>
import axios from 'axios';

import { FingerprintSpinner } from 'epic-spinners';
import NiceDate from '../utility/NiceDate';
import AuditDiff from './AuditDiff';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      loading: false,
      perPage: 25,
      currentPage: 1,
      totalRows: 0,
      filter: '',
      openDiff: false,
      diffSoNum: '',
      logEntries: [],
      columns: [
        'when',
        { key: 'action', label: 'Action (Button Used)' },
        'order',
        'identity',
        'environment',
        'additionalData',
      ]
    }
  },
  components: {
    FingerprintSpinner,
    NiceDate,
    AuditDiff,
  },
  methods: {
    updateLog() {
      let route = '';
      if (this.filter) {
        route = this.filter;
      } else if (this.$route.params.sonum != null) {
        route = this.$route.params.sonum;
      }
      this.loading = true;
      axios.get(`${BASE_API}/audit/${route}`).then(r => {
        this.logEntries = r.data;
        this.totalRows = this.logEntries.length
        this.loading = false
      }).catch(error => console.error(error));
    },
    onFilter(items) {
      this.totalRows = items.length;
      this.currentPage = 1;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/audit/AuditLog.vue